import { render, staticRenderFns } from "./rightPie.vue?vue&type=template&id=3d2b5aae&scoped=true&"
import script from "./rightPie.vue?vue&type=script&lang=js&"
export * from "./rightPie.vue?vue&type=script&lang=js&"
import style0 from "./rightPie.vue?vue&type=style&index=0&id=3d2b5aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b5aae",
  null
  
)

export default component.exports